import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CalculateMfoMutationRequest, CalculateMfoMutationResponse, CalculateMfo400, CalculateMfo401, CalculateMfo403, CalculateMfo404, CalculateMfo410, CalculateMfo422, CalculateMfo429, CalculateMfo500 } from "../types/CalculateMfo";

/**
 * @link /api/credit-flow-backend/v2/express-mfo/do_calculate
 */

export function useCalculateMfo <TData = CalculateMfoMutationResponse, TError = CalculateMfo400 | CalculateMfo401 | CalculateMfo403 | CalculateMfo404 | CalculateMfo410 | CalculateMfo422 | CalculateMfo429 | CalculateMfo500, TVariables = CalculateMfoMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/v2/express-mfo/do_calculate`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
